import { DocumentsService } from "@root/services/documentActions";
import { createAsyncThunk } from "@reduxjs/toolkit";

import {
  CREATE_DOCUMENT_ACTION,
  GET_ALL_DOCUMENTS_ACTION,
  GET_DOCUMENT_BY_ID_ACTION,
  PROCESS_DOCUMENT_ACTION,
} from "@root/store/action-types/documentsActions";
import { getBaseUrl } from "@root/store/selectors/features";
import { isFuncType } from "@root/utils/helpers";

const documentsService = new DocumentsService();

export const createDocument: any = createAsyncThunk(
  CREATE_DOCUMENT_ACTION,
  async (requestPayload: any, thunkAPI: any) => {
    const { onSuccess, onError, formData } = requestPayload;
    try {
      const { data } = await documentsService.createDocument(formData);
      if (isFuncType(onSuccess)) {
        onSuccess(data);
      }
      return thunkAPI.fulfillWithValue(data);
    } catch (error) {
      if (isFuncType(onError)) {
        onError(error);
      }
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const createDocumentWithProgress: any = createAsyncThunk(
  CREATE_DOCUMENT_ACTION,
  async (requestPayload: any, thunkAPI: any) => {
    const { onSuccess, onError, onProgress, formData, signal } = requestPayload;
    try {
      const baseUrl = getBaseUrl(thunkAPI.getState());
      const { data } = await documentsService.createDocumentWithProgress(
        formData,
        onProgress,
        signal
      );
      if (isFuncType(onSuccess)) {
        onSuccess(data);
      }
      return thunkAPI.fulfillWithValue(data);
    } catch (error) {
      if (isFuncType(onError)) {
        onError(error);
      }
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getAllDocuments: any = createAsyncThunk(
  GET_ALL_DOCUMENTS_ACTION,
  async (requestPayload: any, thunkAPI: any) => {
    const { onSuccess, onError, payload } = requestPayload;
    try {
      const { data } = await documentsService.getAllDocuments(payload);
      if (isFuncType(onSuccess)) {
        onSuccess(data);
      }
      return thunkAPI.fulfillWithValue(data);
    } catch (error) {
      if (isFuncType(onError)) {
        onError(error);
      }
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const getDocumentById: any = createAsyncThunk(
  GET_DOCUMENT_BY_ID_ACTION,
  async (requestPayload: any, thunkAPI: any) => {
    const { onSuccess, onError, id } = requestPayload;
    try {
      const { data } = await documentsService.getDocumentById(id);
      if (isFuncType(onSuccess)) {
        onSuccess(data);
      }
      return thunkAPI.fulfillWithValue(data);
    } catch (error) {
      if (isFuncType(onError)) {
        onError(error);
      }
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const processDocument: any = createAsyncThunk(
  PROCESS_DOCUMENT_ACTION,
  async (requestPayload: any, thunkAPI: any) => {
    const { onSuccess, onError, id } = requestPayload;
    try {
      const { data } = await documentsService.processDocument({ id });
      if (isFuncType(onSuccess)) {
        onSuccess(data);
      }
      return thunkAPI.fulfillWithValue(data);
    } catch (error) {
      if (isFuncType(onError)) {
        onError(error);
      }
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const processDocumentReview: any = createAsyncThunk(
  PROCESS_DOCUMENT_ACTION,
  async (requestPayload: any, thunkAPI: any) => {
    const { onSuccess, onError, id } = requestPayload;
    try {
      const { data } = await documentsService.processDocumentReview({
        id,
      });
      if (isFuncType(onSuccess)) {
        onSuccess(data);
      }
      return thunkAPI.fulfillWithValue(data);
    } catch (error) {
      if (isFuncType(onError)) {
        onError(error);
      }
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const processDocumentLegal: any = createAsyncThunk(
  PROCESS_DOCUMENT_ACTION,
  async (requestPayload: any, thunkAPI: any) => {
    const { onSuccess, onError, id } = requestPayload;
    try {
      const { data } = await documentsService.processDocumentLegal({
        id,
      });
      if (isFuncType(onSuccess)) {
        onSuccess(data);
      }
      return thunkAPI.fulfillWithValue(data);
    } catch (error) {
      if (isFuncType(onError)) {
        onError(error);
      }
      return thunkAPI.rejectWithValue(error);
    }
  }
);

export const processMaterialComparison: any = createAsyncThunk(
  PROCESS_DOCUMENT_ACTION,
  async (requestPayload: any, thunkAPI: any) => {
    const { onSuccess, onError, payload } = requestPayload;
    try {
      const { data } = await documentsService.processMaterialComparison(
        payload
      );
      if (isFuncType(onSuccess)) {
        onSuccess(data);
      }
      return thunkAPI.fulfillWithValue(data);
    } catch (error) {
      if (isFuncType(onError)) {
        onError(error);
      }
      return thunkAPI.rejectWithValue(error);
    }
  }
);
